import { ShoppingBag01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Link } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Badge,
  ButtonBase,
  Divider,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import Menu from '@/components/menu/Menu';
import { useResponsive } from '@/hooks';
import { Content } from '@/types';
import './AppBar.scss';

interface Props {
  logo: string;
  phone: number;
  menu?: [];
  products?: Content[];
}

const MyAppBar = ({ logo, phone, menu, products }: Props) => {
  const { isMobile } = useResponsive();
  const theme = useTheme();

  return (
    <AppBar
      id="navigation"
      position="static"
      color="white"
      sx={{
        paddingX: '24px',
        paddingY: '16px',
      }}
    >
      <Toolbar sx={{ paddingX: 0 }}>
        <Stack
          direction={'row'}
          spacing={2}
          sx={{
            flex: 1,
            alignItems: 'center',
            justifyContent: isMobile ? 'space-between' : 'none',
          }}
        >
          <img id="logo" src={logo} height="auto" width="225px" />
          <Divider orientation="vertical" flexItem />
          <Menu menuItems={menu} />
          <Stack
            flex={1}
            spacing={2}
            direction={{
              xs: 'row',
              // md: 'row-reverse'
            }}
            justifyContent="end"
            alignItems="center"
          >
            { isMobile ? null : (
              <a id="phone" href={`tel: ${phone}`}>{phone}</a>
            )}
            <ButtonBase component={Link} to={'/checkout'} sx={{ gap: 1 }} id="cart">
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                color="primary"
                badgeContent={products?.length}
              >
                <Avatar
                  sx={{
                    border: `1px solid ${theme.palette.primary.main}`,
                    color: theme.palette.primary.main,
                    backgroundColor: 'transparent',
                  }}
                >
                  <HugeiconsIcon icon={ShoppingBag01Icon} />
                </Avatar>
              </Badge>
              { isMobile ? null : (
                <Typography>Productos</Typography>
              )}
            </ButtonBase>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default MyAppBar;
